var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaldives(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_669)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 40.0001C31.0455 40.0001 39.9998 31.0458 39.9998 20.0001C39.9998 8.9544 31.0455 9.15527e-05 19.9998 9.15527e-05C8.95412 9.15527e-05 -0.000183105 8.9544 -0.000183105 20.0001C-0.000183105 31.0458 8.95412 40.0001 19.9998 40.0001Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.95642 10.4348H33.0434V29.5653H6.95642V10.4348Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2208 25.6522C20.0992 25.6522 17.5686 23.1216 17.5686 20C17.5686 16.8784 20.0992 14.3478 23.2208 14.3478C24.1941 14.3478 25.1099 14.5939 25.9095 15.0272C24.6552 13.8006 22.9399 13.0434 21.0469 13.0434C17.205 13.0434 14.0904 16.158 14.0904 19.9999C14.0904 23.8419 17.205 26.9564 21.0469 26.9564C22.9399 26.9564 24.6552 26.1993 25.9095 24.9727C25.1099 25.4061 24.1941 25.6522 23.2208 25.6522Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_669"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaldives);
export default __webpack_public_path__ + "static/media/maldives.f7993d90e5d958a4b10f7cbe89f35627.svg";
export { ForwardRef as ReactComponent };